<template>
    <div class="jump-login nav-bar-fixed registe">
        <van-nav-bar title="注册" left-arrow fixed 
        @click-left="back" />
        <div class="jump-login-logo" >
                <img src="../assets/jumuclogo.png" />
        </div>
        <div class="jump-login-body">
            <van-cell-group class="jump-login-body-agree">
              <van-cell title="元兴合作协议用户">
                  <van-switch v-model="agreed" />
              </van-cell>
            </van-cell-group>
            <van-cell-group>
                <van-field 
                    v-model="phone" 
                    placeholder="请输入手机号码"
                    >
                  <i class="iconfont icon-icon--" slot="left-icon"></i>
                </van-field>
                <van-field
                        v-model="trueName"
                        placeholder="请输入真实姓名"
                >
                </van-field>
                <van-field
                    v-model="company"
                    placeholder="选择发货地区"
                    readonly
                    @focus="showPop"
                    >
                  <i class="iconfont icon-ziyuan1" slot="left-icon"></i>
                </van-field>
                <van-field
                    v-model="smsCode"
                    placeholder="请输入短信验证码"
                    >
                  <i class="iconfont icon-mima" slot="left-icon"></i>
                    <van-button :disabled="smsBtnDisabled" slot="button" size="small" type="primary" class="smsBtn" @click="sendCode">
                      {{smsBtnText}}
                    </van-button>
                </van-field>
            </van-cell-group>
            <div class="jump-login-body-foo">
                <p>请选择离您最近的发货地址</p>
                <van-button  size="large" @click="regist">注 册</van-button>
                <van-row>
                  <van-col span="24" class="text-center jump-login-body-foo-btn">
                    <a href="#/login">已有帐号? 点击登录!</a>
                  </van-col>
                  <van-col span="24" class="text-center jump-login-body-foo-treaty">
                    <div class="box">
                      <van-checkbox v-model="checked" /> <span class="agree">我已阅读并同意<a href="#/xieyi">用户服务协议</a></span>
                    </div>
                  </van-col>
                </van-row>
            </div>
        </div>
        <van-popup v-model="popShow" position="bottom" :overlay="true">
            <van-picker 
              :columns="columns" 
              value-key="orgName"
              show-toolbar 
              @cancel="onPickerCancel"
              @confirm="onPickerConfirm" 
            />
        </van-popup>
    </div>
</template>
<script>
import { NavBar,Cell, CellGroup, Field, Button, Row, Col,Switch ,Popup,Picker,Checkbox } from "vant";
import { setInterval, clearInterval } from 'timers';
export default {
  name: "register",
  components: {
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]:Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Switch.name]:Switch ,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    [Checkbox.name]:Checkbox,
  },
  data() {
    return {
      phone: "",
      trueName: "",
      company: "",
      orgId:0,
      smsCode: "",
      agreed:false,
      popShow:false,
      columns:[],
      smsBtnDisabled:false,
      smsBtnText:'获取验证码',
      checked: false,
      ruid:""//推荐人id
    };
  },
  methods: {
    back(){
      location.href = "#/login";
    },
    showPop(){
      this.popShow = true;
    },
    onPickerCancel(){
      this.popShow = false;
    },
    onPickerConfirm(values){
      this.company  = values.orgName;
      this.orgId = values.id;
      this.popShow = false;
    },
    sendCode(){
      let that = this;
      if(!this.checked){
          this.$toast('请先同意用户服务协议');
       }else if(this.phone == ""){
        this.$toast('请填写手机号');
      }else{
        this.$api.get(that.jumuc.user.registerSms,{'mobile':that.phone},
        successRes=>{
          that.$toast(successRes.msg);
          if(successRes.success){
            //发送成功
            that.smsBtnDisabled = true;
            that.smsBtnText = '60秒后重新获取';
            let n = 60;
            let timer = setInterval(function(){
              that.smsBtnText = (n--) + '秒后重新获取';
              if(n==0){
                that.smsBtnDisabled = false;
                that.smsBtnText = '获取验证码';
                clearInterval(timer);
              }
            },1000);
          }
        })
      }
    },
    regist(){
      //注册
      let that = this;
      var flag = true
      var user_type;
      if (this.agreed) {
        user_type = 2;
      }else{
        user_type = 1
      }
      if (!this.checked){
        this.$toast('请先同意用户服务协议');
      }else if(this.phone == ""){
        this.$toast('请填写手机号');
      }else if(this.company == "" || this.orgId==0){
        this.$toast('请选择发货地址');
      }else if(this.smsCode == ""){
        this.$toast('请填写验证码');
      }else{
        this.$api.post(that.jumuc.user.register,
          { 
            'mobile':that.phone,
            'mobileCode':that.smsCode,
            'org_company_id':that.orgId,
            'ruid':that.ruid,
            'user_type':user_type,
            'trueName':that.trueName,
          },
          successRes=>{
            
            if(successRes.success){
              //注册成功
                that.$toast({
                  message:successRes.msg,
                  duration:3000,
                  onClose:function(){
                    that.back();
                  }
                });
            }else{
              that.$toast(successRes.msg);
            }
          })
      }
    }
  },
  mounted(){
    let that = this;
      this.ruid = this.$route.query.ruid;
      this.$api.get(that.jumuc.getOrgList,{},
        successRes=>{
            if(successRes.success){
              that.columns = successRes.data;
            }
        })
  }
};
</script>
<style lang="less" scoped>
.text-center {
  .box {
    width: 230px;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
  }
  .van-checkbox {
    float: left;
    display: inline-block;
    .van-checkbox__icon {
    }
  }
  .agree {
    float: left;
    line-height: 35px;
    margin-left: 5px;
  }
}
@bule-thame: #3C6EEB;
.jump-login {
  &-logo {
    padding: 25px 0;
    text-align: center;
    img {
      width: 95px;
    }
  }
  &-body {
    .van-hairline--top-bottom::after {
      border-top: none;
    }
    &-agree{
      .van-cell__title{
        line-height: 35px;
        color: @bule-thame
      }
    }
    .smsBtn {
      background-color: @bule-thame;
      border-radius: 5px;
      border-color: @bule-thame;
    }
    &-foo {
      padding: 10px 15px;
      font-size: 14px;

      button {
        background-color: @bule-thame;
        border-color: @bule-thame;
        color: white;
        font-weight: 700;
        border-radius: 5px;
        margin: 25px 0 10px;
      }
      p {
        color: @bule-thame;
      }
      &-title {
        text-align: center;
        padding: 25px 0;
      }
      h5 {
        display: inline;
        font-size: 14px;
        position: relative;
        color: #ccc;
      }

      h5:before {
        width: 90px;
        height: 1px;
        content: "";
        position: absolute;
        top: 50%;
        left: -100px;
        background: -webkit-linear-gradient(left, #eeeeee, #dddddd);
        background: -moz-linear-gradient(left, #eeeeee, #dddddd);
        background: linear-gradient(left, #eeeeee, #dddddd);
      }

      h5:after {
        width: 90px;
        height: 1px;
        content: "";
        position: absolute;
        top: 50%;
        right: -100px;
        background: -webkit-linear-gradient(left, #eeeeee, #dddddd);
        background: -moz-linear-gradient(left, #eeeeee, #dddddd);
        background: linear-gradient(left, #eeeeee, #dddddd);
      }
      &-btn a{
        font-size: 16px;
        color: @bule-thame;
      }
      &-treaty{
        padding-top: 10px;
        line-height: 30px;
        vertical-align: middle;
        i{
          vertical-align: middle;
        }
        a{
          margin-left:5px;
          color: @bule-thame; 
        }
      }
    }
    &-icon {
      padding-top: 20px;
      i {
        font-size: 48px;
        color: @bule-thame;
      }
    }
    .van-field__left-icon i{
      font-size: 16px;
    }
  }
}
</style>
